import React from 'react';

interface ConfigRowProps {
  label: string;
  value: string;
  color?: 'green' | 'red' | 'gray' | 'blue';
}

const colorMap: Record<string, string> = {
  green: 'text-green-600',
  red: 'text-red-600',
  gray: 'text-gray-500',
  blue: 'text-blue-600',
};

const ConfigRow: React.FC<ConfigRowProps> = ({ label, value, color }) => (
  <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
    <span className="text-sm text-gray-600">{label}</span>
    <span className={`text-sm font-medium font-mono ${color ? colorMap[color] : 'text-gray-900'}`}>{value}</span>
  </div>
);

export default ConfigRow;
